import HowDoYouGetPaidScreen from 'features/onboarding/screens/HowDoYouGetPaid/HowDoYouGetPaidScreen';
import React from 'react';

export default function Page() {
  return <HowDoYouGetPaidScreen />;
}
